import { api } from 'shared';
import { z } from 'zod';

export const DeliveryArticleCategoriesResponseSchema = z.object({
    data: z.array(
        z.object({
            documentId: z.string(),
            slug: z.string(),
            name: z.string(),
        }),
    ),
});
export const fetchDeliveryArticleCategories = async () => (
    api.get<z.infer<typeof DeliveryArticleCategoriesResponseSchema>>(
        '/delivery-article-categories',
        {},
        DeliveryArticleCategoriesResponseSchema,
    )
);
